<template>
  <v-container fluid id="home">
    <v-row align="center" justify="center" class="mt-12">
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6" md="6" xl="6" class="pl-10">
            <h1 style="font-family: Roboto !important; font-size: 600 !important"
              class="mb-4 text-h6 text-sm-h6 text-md-h5 text-lg-h4 text-xl-h4">
              Halo! My name is Putra Hidayat Arifin <br />
              I'm a
              <span class="oren">Web Developer</span>
            </h1>
            <h2 style="font-family: Roboto !important; font-size: 300"
              class="text-subtitle-2 text-sm-body-2 text-md-subtitle-1 text-lg-h6 text-xl-h4">
              i majored in front end and back end of a website,<br />
              i love to study all the updates for web development<br />
              i also interested in UI/UX Designer.
            </h2>
            <v-row align="center" justify="start"
              class="ml-n8 ml-sm-0 ml-md-0 ml-lg-0 ml-xl-0 mt-5 text-caption text-sm-body-2 text-md-body-1 text-lg-subtitle-1 text-xl-h4">
              <v-col cols="6">
                <v-btn class="text-caption text-sm-body-2 text-md-body-1 text-lg-subtitle-1 text-xl-h4" rounded outlined
                  large dark v-bind="size" @click="$vuetify.goTo('#about')">
                  About Me
                  <v-icon v-bind="size" class="ml-2">mdi-arrow-down-circle-outline</v-icon>
                </v-btn>
              </v-col>
              <!-- <v-col cols="6">
                <v-btn
                  class="text-caption text-sm-body-2 text-md-body-1 text-lg-subtitle-1 text-xl-h4"
                  rounded
                  outlined
                  large
                  dark
                  v-bind="size"
                  href="/"
                  target="_blank"
                > -->
              <!-- @click="$vuetify.goTo('#features')" -->
              <!-- <span>Download CV</span>

                  <v-icon v-bind="size" class="ml-2"
                    >mdi-bookmark-outline</v-icon
                  >
                </v-btn>
              </v-col> -->
            </v-row>
            <!-- <v-img class="wifi" src="~@/assets/img/wifi.png" alt="wifi" />
              <v-img class="hp" src="~@/assets/img/hp.png" alt="hp" /> -->
          </v-col>

          <v-col cols="12" sm="6" md="6" xl="6">
            <!-- <div style="position: absolute">
                <v-row class="ml-10">
                  <v-img
                    class="tekno"
                    src="~@/assets/img/tekno.png"
                    alt="teknologi"
                  />
                  <v-spacer />
                  <v-img
                    class="laptop"
                    src="~@/assets/img/laptop.png"
                    alt="laptop"
                  />
                  <v-img
                    class="vue"
                    src="~@/assets/img/vue.png"
                    alt="vue icon"
                  />
                </v-row>
              </div> -->

            <v-row align="center" justify="center">
              <v-col cols="6">
                <v-img class="tekno ml-6" src="~@/assets/img/tekno.png" alt="teknologi" />
              </v-col>
              <v-col cols="6">
                <v-img class="vue" src="~@/assets/img/vue.png" alt="vue icon" />
              </v-col>
              <v-col cols="12" align="center">
                <v-img class="myfoto" src="~@/assets/img/Putra Hidayat Arifin.png" alt="foto saya" />
              </v-col>
              <!-- <v-img class="file" src="~@/assets/img/file.png" alt="file" />
                <v-img
                  class="laptop"
                  src="~@/assets/img/laptop.png"
                  alt="laptop"
                />
                   <v-img
                    class="keamanan"
                    src="~@/assets/img/keamanan.png"
                    alt="keamanan"
                  /> -->
            </v-row>

            <v-row align="center" justify="center">
              <!-- partial:index.partial.html -->
              <div class="pb-16">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                  <defs>
                    <filter id="shadowed-goo">
                      <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                      <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
                        result="goo" />
                      <feGaussianBlur in="goo" stdDeviation="3" result="shadow" />
                      <feBlend in2="goo" in="SourceGraphic" result="mix" />
                    </filter>
                  </defs>
                </svg>
                <div id="menubutton">
                  <nav>
                    <input type="checkbox" href="#" id="menu-open" />
                    <label class="menu-open-button" for="menu-open">
                      <v-icon color="black">mdi-menu</v-icon>
                    </label>
                    <a target="blank" href="mailto:putrahidayatarifin@gmail.com" class="menu-item"
                      aria-label="click to go to my email">
                      <v-icon aria-label="gmail icon" color="black">mdi-gmail</v-icon>
                    </a>
                    <a target="blank" href="https://www.instagram.com/pu_hi_ar" class="menu-item"
                      aria-label="click to go to my instagram">
                      <v-icon aria-label="instagram icon" color="black">mdi-instagram</v-icon>
                    </a>
                    <a target="blank" href="https://www.linkedin.com/in/putra-hidayat-1a8a901a5" class="menu-item"
                      aria-label="click to go to my linkedin">
                      <v-icon aria-label="linkedin icon" color="black">mdi-linkedin</v-icon>
                    </a>
                    <a target="blank" href="https://github.com/PutraHidayatA" class="menu-item"
                      aria-label="click to go to my github">
                      <v-icon aria-label="github icon" color="black">mdi-github</v-icon>
                    </a>
                    <a target="blank" href="https://www.facebook.com/dayat.keren.5268" class="menu-item"
                      aria-label="click to go to my facebook">
                      <v-icon aria-label="facebook icon" color="black">mdi-facebook</v-icon>
                    </a>
                  </nav>
                </div>
              </div>
              <!-- partial -->
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.path-0 {
  animation: pathAnim-0 4s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes pathAnim-0 {
  0% {
    d: path("M 0,700 C 0,700 0,350 0,350 C 28.77737627162456,367.8251549748056 57.55475254324912,385.6503099496113 83,373 C 108.44524745675088,360.3496900503887 130.55836609862806,317.22391517636044 155,294 C 179.44163390137194,270.77608482363956 206.21178306223857,267.45402934494706 225,309 C 243.78821693776143,350.54597065505294 254.5945016524176,436.9599674438515 277,430 C 299.4054983475824,423.0400325561485 333.410210328091,322.7061008796469 359,321 C 384.589789671909,319.2938991203531 401.76465703521853,416.2156290375608 423,443 C 444.23534296478147,469.7843709624392 469.53116153103474,426.4313829701098 493,407 C 516.4688384689653,387.5686170298902 538.1106968406424,392.05883908200036 565,403 C 591.8893031593576,413.94116091799964 624.0260511063955,431.3332607018888 649,420 C 673.9739488936045,408.6667392981112 691.7850987337757,368.60811811044437 718,364 C 744.2149012662243,359.39188188955563 778.8335539585019,390.23426685633376 803,406 C 827.1664460414981,421.76573314366624 840.880685432217,422.4548144642208 861,431 C 881.119314567783,439.5451855357792 907.6437043126303,455.9464752867832 930,417 C 952.3562956873697,378.0535247132168 970.5444973172621,283.7592843886465 1000,300 C 1029.455502682738,316.2407156113535 1070.1783064183207,443.01638715863066 1093,470 C 1115.8216935816793,496.98361284136934 1120.7422770094554,424.17516697683095 1141,396 C 1161.2577229905446,367.82483302316905 1196.8525855438572,384.2829449340453 1223,380 C 1249.1474144561428,375.7170550659547 1265.8473808151155,350.6930532869878 1288,320 C 1310.1526191848845,289.3069467130122 1337.7578911956812,252.94484191800348 1364,257 C 1390.2421088043188,261.0551580819965 1415.1210544021594,305.52757904099826 1440,350 C 1440,350 1440,700 1440,700 Z"
      );
  }

  25% {
    d: path("M 0,700 C 0,700 0,350 0,350 C 27.57761611490549,408.9321628595376 55.15523222981098,467.86432571907517 76,432 C 96.84476777018902,396.13567428092483 110.95668719566157,265.4748599832369 132,251 C 153.04331280433843,236.5251400167631 181.01801898754277,338.2362343479773 212,401 C 242.98198101245723,463.7637656520227 276.97123685416744,487.58020262485394 297,479 C 317.02876314583256,470.41979737514606 323.0970335957874,429.4429551526071 348,417 C 372.9029664042126,404.5570448473929 416.64062876268287,420.64797676471767 444,391 C 471.35937123731713,361.35202323528233 482.34045135348117,285.96513778852227 503,262 C 523.6595486465188,238.03486221147776 553.9975658233923,265.4914720811934 580,317 C 606.0024341766077,368.5085279188066 627.6692853529495,444.0689738867042 649,437 C 670.3307146470505,429.9310261132958 691.32529276481,340.2326323719897 714,325 C 736.67470723519,309.7673676280103 761.0295435878105,369.00049662533684 788,370 C 814.9704564121895,370.99950337466316 844.5565328839484,313.765381126663 869,291 C 893.4434671160516,268.234618873337 912.7443248763955,279.93797886801116 936,312 C 959.2556751236045,344.06202113198884 986.4661676104699,396.4827034012925 1011,400 C 1035.53383238953,403.5172965987075 1057.3910046817246,358.1312075268188 1080,378 C 1102.6089953182754,397.8687924731812 1125.9698136626319,482.99246649143254 1151,480 C 1176.0301863373681,477.00753350856746 1202.729740667748,385.89892650745105 1229,326 C 1255.270259332252,266.10107349254895 1281.1112236663753,237.41182747876314 1305,253 C 1328.8887763336247,268.58817252123686 1350.8253646667497,328.45376357749626 1373,352 C 1395.1746353332503,375.54623642250374 1417.587317666625,362.77311821125187 1440,350 C 1440,350 1440,700 1440,700 Z"
      );
  }

  50% {
    d: path("M 0,700 C 0,700 0,350 0,350 C 26.53849436733605,394.4368530794191 53.0769887346721,438.8737061588382 80,436 C 106.9230112653279,433.1262938411618 134.23053942864766,382.94202844406607 157,359 C 179.76946057135234,335.05797155593393 198.00085355073722,337.35818006489734 217,330 C 235.99914644926278,322.64181993510266 255.76604636840347,305.6252512963446 277,310 C 298.23395363159653,314.3747487036554 320.93496097564883,340.1408147497243 350,341 C 379.06503902435117,341.8591852502757 414.4941097290011,317.81148970475806 437,328 C 459.5058902709989,338.18851029524194 469.08860010834667,382.6132264312435 493,357 C 516.9113998916533,331.3867735687565 555.1514898376121,235.73560457026792 584,264 C 612.8485101623879,292.2643954297321 632.3054405412049,444.4443552876849 650,466 C 667.6945594587951,487.5556447123151 683.626747997568,378.48697427899236 710,376 C 736.373252002432,373.51302572100764 773.1875674685231,477.6077475963458 800,472 C 826.8124325314769,466.3922524036542 843.6229821283399,351.0820353356245 863,301 C 882.3770178716601,250.91796466437555 904.3205040181172,266.0641110611565 932,278 C 959.6794959818828,289.9358889388435 993.0950017991916,298.6615204197496 1017,340 C 1040.9049982008084,381.3384795802504 1055.2994887851166,455.2898072598451 1078,474 C 1100.7005112148834,492.7101927401549 1131.7070430603414,456.1792505408702 1158,386 C 1184.2929569396586,315.8207494591298 1205.8723389735167,211.99319057667398 1226,222 C 1246.1276610264833,232.00680942332602 1264.8036010455917,355.84798715243386 1289,391 C 1313.1963989544083,426.15201284756614 1342.9132568441166,372.6148608135903 1369,351 C 1395.0867431558834,329.3851391864097 1417.5433715779418,339.69256959320484 1440,350 C 1440,350 1440,700 1440,700 Z"
      );
  }

  75% {
    d: path("M 0,700 C 0,700 0,350 0,350 C 24.401899846912563,365.62259380570913 48.80379969382513,381.2451876114182 75,381 C 101.19620030617487,380.7548123885818 129.18670107161205,364.6418433600364 155,352 C 180.81329892838795,339.3581566399636 204.44939601972672,330.18743894843647 227,324 C 249.55060398027328,317.81256105156353 271.0157148494811,314.60840084621776 294,304 C 316.9842851505189,293.39159915378224 341.48774458234885,275.3789576666925 365,298 C 388.51225541765115,320.6210423333075 411.03330682112335,383.87576848701235 430,354 C 448.96669317887665,324.12423151298765 464.37902813315736,201.11796838525814 491,221 C 517.6209718668426,240.88203161474186 555.450580646247,403.652357971955 582,470 C 608.549419353753,536.347642028045 623.8186492818546,506.2725997269219 641,469 C 658.1813507181454,431.7274002730781 677.2748222263343,387.25724312035743 706,393 C 734.7251777736657,398.74275687964257 773.0820618128081,454.69842779164844 798,431 C 822.9179381871919,407.30157220835156 834.3969305224332,303.94904571304863 855,303 C 875.6030694775668,302.05095428695137 905.3302160974594,403.50538935615714 929,400 C 952.6697839025406,396.49461064384286 970.2822050877295,288.02939686232287 996,284 C 1021.7177949122705,279.97060313767713 1055.5409635516226,380.3770231945515 1083,406 C 1110.4590364483774,431.6229768054485 1131.5539407057806,382.462510359471 1154,393 C 1176.4460592942194,403.537489640529 1200.2432736252547,473.7729353675645 1227,472 C 1253.7567263747453,470.2270646324355 1283.4729647932006,396.4457481702711 1308,392 C 1332.5270352067994,387.5542518297289 1351.8648672019426,452.4440719513511 1373,457 C 1394.1351327980574,461.5559280486489 1417.0675663990287,405.77796402432443 1440,350 C 1440,350 1440,700 1440,700 Z"
      );
  }

  100% {
    d: path("M 0,700 C 0,700 0,350 0,350 C 28.77737627162456,367.8251549748056 57.55475254324912,385.6503099496113 83,373 C 108.44524745675088,360.3496900503887 130.55836609862806,317.22391517636044 155,294 C 179.44163390137194,270.77608482363956 206.21178306223857,267.45402934494706 225,309 C 243.78821693776143,350.54597065505294 254.5945016524176,436.9599674438515 277,430 C 299.4054983475824,423.0400325561485 333.410210328091,322.7061008796469 359,321 C 384.589789671909,319.2938991203531 401.76465703521853,416.2156290375608 423,443 C 444.23534296478147,469.7843709624392 469.53116153103474,426.4313829701098 493,407 C 516.4688384689653,387.5686170298902 538.1106968406424,392.05883908200036 565,403 C 591.8893031593576,413.94116091799964 624.0260511063955,431.3332607018888 649,420 C 673.9739488936045,408.6667392981112 691.7850987337757,368.60811811044437 718,364 C 744.2149012662243,359.39188188955563 778.8335539585019,390.23426685633376 803,406 C 827.1664460414981,421.76573314366624 840.880685432217,422.4548144642208 861,431 C 881.119314567783,439.5451855357792 907.6437043126303,455.9464752867832 930,417 C 952.3562956873697,378.0535247132168 970.5444973172621,283.7592843886465 1000,300 C 1029.455502682738,316.2407156113535 1070.1783064183207,443.01638715863066 1093,470 C 1115.8216935816793,496.98361284136934 1120.7422770094554,424.17516697683095 1141,396 C 1161.2577229905446,367.82483302316905 1196.8525855438572,384.2829449340453 1223,380 C 1249.1474144561428,375.7170550659547 1265.8473808151155,350.6930532869878 1288,320 C 1310.1526191848845,289.3069467130122 1337.7578911956812,252.94484191800348 1364,257 C 1390.2421088043188,261.0551580819965 1415.1210544021594,305.52757904099826 1440,350 C 1440,350 1440,700 1440,700 Z"
      );
  }
}

/* 
  .wifi {
  max-width: 8%;
  position: absolute;
  bottom: 50px;
  left: 100px;
  animation: KiriKanan 2s linear 0s infinite alternate none;
} */
/* .hp {
  max-width: 8%;
  position: absolute;
  bottom: 30px;
  left: 300px;
  animation: KiriKanan 1s linear 0s infinite alternate none;
} */
/* .keamanan {
  position: absolute;
  z-index: 1;
  max-width: 20%;
  right: 8vw;
  animation: AtasBawah 2s linear 0s infinite alternate none;
} */
/* .file {
  position: absolute;
  z-index: 1;
  max-width: 10%;
  right: 35%;
  animation: AtasBawah 1s linear 0s infinite alternate none;
} */
/* .laptop {
  position: absolute;
  z-index: 1;
  margin-top: 15%;
  max-width: 20%;
  right: 20%;
  animation: AtasBawah 2s linear 0s infinite alternate none;
} */
#home {
  background-color: var(--var4);
  /* height: 100%; */
  z-index: 0;
  color: var(--var6);
  margin: -2px;
}

.myfoto {
  z-index: 1;
  max-width: 80%;
  border-radius: 20px;
  width: 100%;
  height: 100%;
}

.tekno {
  position: absolute;
  z-index: 1;
  max-width: 15%;
  animation: Roda 10s linear 0s infinite normal none;
  width: 75px;
  height: 75px;
}

.vue {
  position: absolute;
  z-index: 1;
  right: 5%;
  max-width: 20%;
  animation: Vue 3s ease 0s infinite alternate both;
  width: 75px;
  height: 75px;
}

@keyframes Roda {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes Vue {

  0%,
  100% {
    transform: translateX(0%);
    transform-origin: 50% 50%;
  }

  15% {
    transform: translateX(-20px) rotate(-6deg);
  }

  30% {
    transform: translateX(15px) rotate(6deg);
  }

  45% {
    transform: translateX(-15px) rotate(-3.6deg);
  }

  60% {
    transform: translateX(9px) rotate(2.4deg);
  }

  75% {
    transform: translateX(-6px) rotate(-1.2deg);
  }
}

/* @keyframes AtasBawah {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-20px);
  }
}
@keyframes KiriKanan {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(30px);
  }
} */

/* tes */
#menubutton {
  -webkit-box-align: center;
  -webkit-box-pack: center;
  display: -webkit-box;
  bottom: 90px;
  position: relative;
  right: 10%;
}

.menu-open-button {
  position: absolute;
  min-width: 64px;
  min-height: 64px;
  font-size: 28px;
  color: var(--var1);
  border-radius: 50%;
  background: var(--var5);
  margin-top: -64px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 400ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition: all 400ms cubic-bezier(0.935, 0, 0.34, 1.33);
}

label,
.menu-item {
  min-width: 64px;
  min-height: 64px;
  font-size: 28px;
  color: var(--var5);
  border-radius: 50%;
  background: var(--var5);
}

nav {
  filter: url("#shadowed-goo");
}

.menu-item {
  position: absolute;
  margin-top: -64px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 400ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition: all 400ms cubic-bezier(0.935, 0, 0.34, 1.33);
}

.menu-item:hover {
  transform: scale(1.2);
}

.menu-item:hover {
  background-color: var(--var1);
  color: var(--var1);
}

.menu-item:nth-child(1) {
  transition-duration: 70ms;
}

.menu-item:nth-child(2) {
  transition-duration: 130ms;
}

.menu-item:nth-child(3) {
  transition-duration: 190ms;
}

.menu-item:nth-child(4) {
  transition-duration: 250ms;
}

.menu-item:nth-child(5) {
  transition-duration: 310ms;
}

input {
  display: none;
  filter: url("#shadowed-goo");
}

input+label {
  transition: all 200ms linear;
}

input:checked+label {
  transform: scale(0.8);
}

input:checked~.menu-item:nth-of-type(1) {
  transform: translate(-170%, 45%);
}

input:checked~.menu-item:nth-of-type(2) {
  transform: translate(-100%, 135%);
}

input:checked~.menu-item:nth-of-type(3) {
  transform: translate(170%, 45%);
}

input:checked~.menu-item:nth-of-type(4) {
  transform: translate(100%, 135%);
}

input:checked~.menu-item:nth-of-type(5) {
  transform: translate(0%, 160%);
}

label {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 400ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

label:hover {
  transform: scale(1.2);
}

/* tes */
</style>

<script>
export default {
  data() {
    return {
      dialog: false,
      // pdfLink: require("@/assets/file/CV_Putra Hidayat Arifin.pdf"),
    };
  },

  computed: {
    size() {
      const size = { xs: "x-small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size
        ? {
          [size]: true,
        }
        : {};
    },
  },

  watch: {
    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },
};
</script>
